import React from "react";
import { dateWrapper } from "core/lib/date.wrapper";

type QueryDetailsRowProps = {
  supportQuery: any,
  onClick: any,
  clickable: boolean
}

const QueryDetailsRow = (props: QueryDetailsRowProps) => {
  const { supportQuery, onClick, clickable = false } = props;

  const buttonCssName = !clickable ? "not-clickable" : "";

  const dateString = dateWrapper(supportQuery.created_at).shortDate;

  return (
    <li
      onClick={(e) => {
        if (onClick && clickable) {
          onClick(e, supportQuery.id);
        }
      }}>
      <p className="info-details-header">
        <span className="title">{supportQuery.subject}</span>
        <span className="reference">Reference: {supportQuery.id}</span>
        <i className="icon-Arrow_right_thin"></i>
      </p>

      <ul className="info-details four-items">
        <li>
          <label>Date</label>
          {dateString}
        </li>
        <li className="submitted-by">
          <label>Submitted by</label>
          {supportQuery.submittedBy || supportQuery.createdBy}
        </li>
        <li>
          <label>Category</label>
          {supportQuery.category}
        </li>
        <li className={`status-${supportQuery.status?.toString()?.toLowerCase()}`}>
          <label>Status</label>
          {supportQuery.status}
        </li>
        <li>
          <button
            type="button"
            className={buttonCssName}>
            <i className="icon-Arrow_right_thin"></i>
          </button>
        </li>
      </ul>
    </li>
  );
}

export default QueryDetailsRow;
